<script lang="ts">
    import { useNavigate } from 'svelte-navigator'
    import sessionStore from '../../store/session';
    import type { Profile } from '../../types/session';
    import AuthHeader from '../../components/AuthHeader.svelte';
    // import AuthFooter from '../../components/AuthFooter.svelte';

    const navigate = useNavigate();
    let profile: Profile | any = $sessionStore.profile
</script>

<AuthHeader />
<div class="flex h-full flex-col mx-4 overflow-y-scroll">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="text-gray-500 flex items-center mt-1" on:click={() => navigate(-1)}>
        <span class="p-1 border border-gray-300 rounded-md cursor-pointer mr-1">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.785 2.965L1.75 6L4.785 9.035" stroke="#344054" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.25 6H1.83496" stroke="#344054" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>                     
        </span>
        Go Back
    </div>
    <h3 class="text-md font-bold my-3 secondary-text-color">Profile Information</h3>
    <div class="text-xs mb-3">
        <div class="bg-gray-100 font-black py-1 my-2 primary-text-color">Personal Information</div>
        <div class="grid grid-cols-2 text-gray-500">
            <div class="my-1">First Name:</div><div class="my-1">{ profile.first_name }</div>
            <div class="my-1">Last Name:</div><div class="my-1">{ profile.last_name }</div>
            <div class="my-1">Phone Number:</div><div class="my-1">{ profile.mobile }</div>
            <div class="my-1">Work Email Address:</div><div class="my-1">{ profile.email }</div>
        </div>
    </div>
    <hr/>
    <div class="text-xs mt-3">
        <div class="bg-gray-100 font-black py-1 my-2 primary-text-color">Business Information</div>
        <div class="grid grid-cols-2 text-gray-500">
            <div class="my-1">Business Name:</div><div class="my-1">{ profile.business.name }</div>
            <div class="my-1">Business Email:</div><div class="my-1">{ profile.business.email }</div>
            <div class="my-1">Country of Operation:</div><div class="my-1">{ profile.business.address }</div>
            <div class="my-1">Role:</div><div class="my-2">{ profile.role }</div>
        </div>
    </div>
</div>
<style>
    .primary-text-color {
        color: var(--primary-text-color)
    }
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
</style>
